<script lang="ts">
    import {onMount} from "svelte";
    import {OfferItem} from "../entities/OfferItem";
    import {assets} from "../three/assets/materials";
    import {createRenderer} from "../three/Renderer";
    import * as THREE from "three";
    import {Scene} from "../three/Scene";
    import ExtraSelector from "./ExtraSelector.svelte";
    import RotationButton from "./RotationButton.svelte";

    export let offerItem: OfferItem;
    export let updateFormData: Function
    // For the dialog
    export let modalId: number

    let freeRotation: boolean = true;
    let renderer: THREE.WebGLRenderer;
    let canvasElem: HTMLCanvasElement;
    let scene: Scene;
    let loaded = false

    $: {
        if (scene) {
            if (JSON.stringify(scene.formData) !== JSON.stringify(offerItem)) {
                scene.stopRender()
                scene.disposeAll()
                scene.rebuild(offerItem)
            }
            scene.camera.setCameraFreeRotation(freeRotation)
        }
    }

    onMount(async () => {
        renderer = createRenderer(canvasElem)
        // Waits for all assets to load then builds the scene
        createScene(offerItem)
    });

    function createScene(data: OfferItem) {
        assets.ensureLoaded(() => {
            scene = new Scene(canvasElem, renderer, setSelectedSide, updateFormData);
            scene.build(data)
            loaded = true
            scene.camera.setCameraFreeRotation(freeRotation)
        })
    }
    let selectedSide = null

    function setSelectedSide(side: string) {
        scene.selectedSide = side
        selectedSide = side
    }

    /**
     * Called on window resize
     * Resizes the scene to fit the new viewport
     */
    function resize() {
        if (!scene) return
        scene.resize();
    }
</script>

<svelte:window on:resize={resize}/>
<div class="lg:flex lg:justify-end h-96 w-full sm:h-full relative" style="max-height: 750px;">
    <canvas class="w-full lg:w-3/4 h-full" bind:this={canvasElem}></canvas>
    {#if scene}
        <RotationButton bind:freeRotation={freeRotation}/>
    {/if}
</div>
{#if scene}
    <ExtraSelector bind:modalId={modalId} bind:currentItem={offerItem} bind:scene={scene} bind:selectedSide={selectedSide} updateFormData={updateFormData}/>
{/if}
{#if loaded === false}
    <span>Loading...</span>
{/if}